import mainService from "services/mainService";

/**
 * @description Busca a lista de profissionais interessados em um estabelecimento
 * @param {Object} params
 * @param {number} params.establishmentId
 * @param {number} params.page
 * @param {number} params.pageSize
 * @returns {Promise}
 * @example getWorkersInterests({ establishmentId: 1, page: 1, pageSize: 10 });
 */
export const getWorkersInterests = async ({
  establishmentId,
  page,
  pageSize,
}) => {
  return mainService.get(
    `v2/establishment/${establishmentId}/worker_interests?page=${page}&page_size=${pageSize}`
  );
};

/**
 * @description Adiciona um ou múltiplos profissionais em um estabelecimento
 * @param {Object} params
 * @param {number} params.establishmentId
 * @param {Array<number>} params.interestsIds
 * @returns {Promise}
 * @example acceptInterestsWorkers({ establishmentId: 1, interestsIds: [1, 2, 3] });
 */
export const acceptInterestsWorkers = async ({
  establishmentId,
  interestsIds,
}) => {
  return mainService.post(
    `v2/establishment/${establishmentId}/worker_interests/accept`,
    {
      interests_ids: interestsIds,
    }
  );
};

/**
 * @description Remove um ou múltiplos profissionais em um estabelecimento
 * @param {Object} params
 * @param {number} params.establishmentId
 * @param {Array<number>} params.interestsIds
 * @returns {Promise}
 * @example rejectInterestsWorkers({ establishmentId: 1, interestsIds: [1, 2, 3] });
 */
export const rejectInterestsWorkers = async ({
  establishmentId,
  interestsIds,
}) => {
  return mainService.post(
    `v2/establishment/${establishmentId}/worker_interests/reject`,
    {
      interests_ids: interestsIds,
    }
  );
};

/**
 * @description Verifica se pode exibir a lista de profissionais interessados em um estabelecimento
 * @param {Object} params - Parâmetros da requisição
 * @param {number} params.establishmentId - ID do estabelecimento
 * @returns {Promise}
 * @example getCanShowInterests({ establishmentId: 1 });
 */
export const getCanShowInterests = async ({ establishmentId }) => {
  return mainService.get(
    `v2/establishment/${establishmentId}/should_show_interests`
  );
};
